export const WINDOW_SIZES = {
  MOBILE: 768,
  TABLET: 1024,
  DESKTOP: 1440,
};
